module.exports = __webpack_public_path__ + "images/places-bg-532f1a9587e0a4acfb4de20b01bc5cb2.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places-bg.svg
 ** module id = 427
 ** module chunks = 0
 **/